import { Injectable } from '@angular/core';

import { ChargeType } from '../../../models';
import { TmsWebBaseEditService } from '../../base';

@Injectable({
  providedIn: 'root',
})
export class ChargeTypeService extends TmsWebBaseEditService<ChargeType, ChargeType> {
  constructor() {
    super('ChargeType', $localize`Charge Type`);
  }
}
